import $ from "jquery";

export const distance = (a, b) => {
  a.x = parseInt(a.x, 10)
  a.y = parseInt(a.y, 10)
  b.x = parseInt(b.x, 10)
  b.y = parseInt(b.y, 10)
  return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y));
};

export const getRoutePoints = (vertices, marginTop, config) => {
  let waypoints = [];
  for (let i = 1; i < vertices.length; i++) {
    let pt0 = vertices[i - 1];
    let pt1 = vertices[i];
    // Usar las coordenadas originales y aplicar la misma transformación que los iconos
    let trans0 = transformWindowCoordinateToCanvasCoord(pt0.x, pt0.y, config.w, config.h);
    let trans1 = transformWindowCoordinateToCanvasCoord(pt1.x, pt1.y, config.w, config.h);
    let dx = trans1.x - trans0.x;
    let dy = trans1.y - trans0.y;
    let density = Math.sqrt(dx * dx + dy * dy) / 2;
    for (let j = 0; j < density; j++) {
      let x = trans0.x + dx * (j / density);
      let y = trans0.y + dy * (j / density);
      waypoints.push({ x: x, y: y });
    }
  }
  return waypoints;
};

export const transformWindowCoordinateToCanvasCoord = (x, y, w, h) => {
  let deg = 16 * Math.PI / 180;
  let xRotated = x * Math.cos(deg) + y * Math.sin(deg);
  let yRotated = -x * Math.sin(deg) + y * Math.cos(deg);
  let width = $(window).width();
  let xPrima = width * xRotated /w;
  let height = width * h / w;
  let yPrima = height * yRotated  / h;
  return {
    x: xPrima,
    y: yPrima,
    margin: height * y  / h
  }
}


// WEBPACK FOOTER //
// ./src/utils/calc.js